import { render, staticRenderFns } from "./PriceReport.vue?vue&type=template&id=f8b47dd6"
import script from "./PriceReport.vue?vue&type=script&lang=js"
export * from "./PriceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports